import { cloneElement } from "react";
import {
  BiAccessibility,
  BiBeer,
  BiBus,
  BiCableCar,
  BiCake,
  BiCamera,
  BiCoffee,
  BiCycling,
  BiDoorOpen,
  BiDrink,
  BiError,
  BiGift,
  BiHeartSquare,
  BiLandscape,
  BiMusic,
  BiRestaurant,
  BiRun,
  BiSolidShip,
  BiStore,
  BiTrain,
} from "react-icons/bi";
import { BsTicketPerforated } from "react-icons/bs";
import { FaToriiGate } from "react-icons/fa";
import { GiDango, GiKimono } from "react-icons/gi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { IconBaseProps } from "react-icons/lib";
import { MdOutlineStadium, MdOutlineTempleBuddhist } from "react-icons/md";
import { PiBackpack, PiBowlFood } from "react-icons/pi";
import { TbBottle } from "react-icons/tb";
import { MtBoatIcon } from "./MtBoatIcon";
import { MtBoxingIcon } from "./MtBoxingIcon";
import { MtCartIcon } from "./MtCartIcon";
import { MtCookingClass } from "./MtCookingClassIcon";
import { MtDressCodeIcon } from "./MtDressCodeIcon";
import { MtGuideIcon } from "./MtGuideIcon";
import { MtInsuranceIcon } from "./MtInsuranceIcon";
import { MtTempleIcon } from "./MtTempleIcon";
import { MtThaiFood2Icon } from "./MtThaiFood2Icon";
import { MtThaiSweetIcon } from "./MtThaiSweetIcon";
import { MtThaiTeaIcon } from "./MtThaiTeaIcon";
import { MtTuktukIcon } from "./MtTuktukIcon";

const icons = new Map([
  ["BiAccessibility", <BiAccessibility />],
  ["BiBeer", <BiBeer />],
  ["BiBus", <BiBus />],
  ["BiCableCar", <BiCableCar />],
  ["BiCake", <BiCake />],
  ["BiCamera", <BiCamera />],
  ["BiCoffee", <BiCoffee />],
  ["BiCycling", <BiCycling />],
  ["BiDoorOpen", <BiDoorOpen />],
  ["BiDrink", <BiDrink />],
  ["BiGift", <BiGift />],
  ["BiHeartSquare", <BiHeartSquare />],
  ["BiLandscape", <BiLandscape />],
  ["BiMusic", <BiMusic />],
  ["BiRestaurant", <BiRestaurant />],
  ["BiRun", <BiRun />],
  ["BiSolidShip", <BiSolidShip />],
  ["BiStore", <BiStore />],
  ["BiTrain", <BiTrain />],
  ["BsTicketPerforated", <BsTicketPerforated />],
  ["FaToriiGate", <FaToriiGate />],
  ["GiDango", <GiDango />],
  ["MdOutlineStadium", <MdOutlineStadium />],
  ["MdOutlineTempleBuddhist", <MdOutlineTempleBuddhist />],
  ["MtGuide", <MtGuideIcon />],
  ["PiBackpack", <PiBackpack />],
  ["PiBowlFood", <PiBowlFood />],
  ["TbBottle", <TbBottle />],
  ["GiKimono", <GiKimono />],
  ["IoDocumentTextOutline", <IoDocumentTextOutline />],
  ["MtTuktuk", <MtTuktukIcon />],
  ["MtBoat", <MtBoatIcon />],
  ["MtTemple", <MtTempleIcon />],
  ["MtCart", <MtCartIcon />],
  ["MtCookingClass", <MtCookingClass />],
  ["MtBoxing", <MtBoxingIcon />],
  ["MtInsurance", <MtInsuranceIcon />],
  ["MtThaiSweet", <MtThaiSweetIcon />],
  ["MtThaiTea", <MtThaiTeaIcon />],
  ["MtDressCode", <MtDressCodeIcon />],
  ["MtThaiFood2", <MtThaiFood2Icon />],
]);

export const iconNames = Array.from(icons.keys());

export function getIcon(iconName: string, props?: IconBaseProps) {
  const icon = icons.get(iconName) ?? <BiError />;
  return cloneElement(icon, { ...props });
}
